/**
 * Contribution represents an author contribution to a diagnosis.
 */
class Contribution {
  static EDITOR: Contribution;
  static CONTRIBUTOR: Contribution;
  static REVIEWER: Contribution;
  static LAYOUT: Contribution;

  private static _values: Contribution[] = [];
  private static _lookup: Map<string, Contribution> = new Map();

  static fromKey(key?: string) {
    const instance = Contribution._lookup.get(key !== undefined ? key : 'n/a');
    if (instance === undefined) {
      throw new Error('Not a valid Contribution.id: ' + key);
    }
    return instance;
  }

  static values(): Contribution[] {
    return [...Contribution._values];
  }

  // ---

  public readonly id: string;
  public readonly label: string;
  public readonly order: number;

  constructor(id: string, label: string, order: number = 0) {
    this.id = id;
    this.label = label;
    this.order = order;
    Contribution._values.push(this);
    Contribution._lookup.set(id, this);
  }

  toJson(): { id: string; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Contribution: ' + this.id + ", label='" + this.label + "'>";
  }
}

Contribution.EDITOR = new Contribution('e', 'Editor', 10);
Contribution.CONTRIBUTOR = new Contribution('c', 'Contributor', 20);
Contribution.REVIEWER = new Contribution('r', 'Reviewer', 30);
Contribution.LAYOUT = new Contribution('l', 'Layout', 40);

export { Contribution };
